import axiosInstance from '../../api/axios';
import { scopeParams, type AnalyticsScope } from './scope.ts';

// Types mirror the new `/api/analytics/reviewer/*` endpoints verbatim — see
// specs/20-contracts/feedback-round-2026-08.md. New 6th persona (dashboard_key
// 'reviewer') added in this feedback round. Do not rename fields without
// updating both sides of the contract.

/** GET /api/analytics/reviewer/queue */
export type ReviewerQueueItem = {
  test_run_id: string;
  control_id: string;
  control_title: string;
  tester_name: string | null;
  workflow_status: string;
  completed_at: string | null;
  days_waiting: number;
};
export type ReviewerQueueResponse = { total: number; items: ReviewerQueueItem[] };

/** GET /api/analytics/reviewer/summary */
export type ReviewerByTesterRow = { tester_name: string; pending: number };
export type ReviewerSummaryResponse = {
  pending_review: number;
  reviewed_count: number;
  avg_days_waiting: number;
  by_tester: ReviewerByTesterRow[];
};

const BASE = '/api/analytics/reviewer';

export const fetchReviewerQueue = async (scope?: AnalyticsScope): Promise<ReviewerQueueResponse> => {
  const response = await axiosInstance.get<ReviewerQueueResponse>(`${BASE}/queue`, { params: scopeParams(scope) });
  return response?.data ?? { total: 0, items: [] };
};

export const fetchReviewerSummary = async (scope?: AnalyticsScope): Promise<ReviewerSummaryResponse> => {
  const response = await axiosInstance.get<ReviewerSummaryResponse>(`${BASE}/summary`, { params: scopeParams(scope) });
  return response?.data ?? { pending_review: 0, reviewed_count: 0, avg_days_waiting: 0, by_tester: [] };
};
